import CentralApiService from "../../centralApiServices";


class CadastroContasAPagarService extends CentralApiService {

    constructor() {
        super('/api/cadastroContasAPagar')
    }


    createGrupoDePagamento(grupoDePagamento){
        return this.post(`/createGrupoDePagamento`, grupoDePagamento)
    }

    updateGrupoDePagamento(grupoDePagamento){
        return this.put(`/updateGrupoDePagamento`, grupoDePagamento)
    }

    deleteGrupoDePagamentoByUuid(uuid){
        return this.delete(`/deleteGrupoDePagamentoByUuid/${uuid}`)
    }


    createTipoDreCompetencia(tipoDreCompetencia){
        return this.post(`/createTipoDreCompetencia`, tipoDreCompetencia)
    }

    updateTipoDreCompetencia(tipoDreCompetencia){
        return this.put(`/updateTipoDreCompetencia`, tipoDreCompetencia)
    }    

    deleteTipoDreCompetenciaByUuid(uuid){
        return this.delete(`/deleteTipoDreCompetenciaByUuid/${uuid}`)
    }

}

export default CadastroContasAPagarService